



















































































































































































































































































































































































































































import { Component, Vue, Prop } from 'vue-property-decorator';
import moment from 'moment-timezone';
import './style.scss';
import {
  formatNumber,
  getOrderItemCardIcon,
  showConfirmButton,
} from '@/utils/helpers';
import constants from '@/utils/constants';

@Component({
  filters: {
    formatDate(val: any) {
      let date: any = val;
      if (moment(date).isValid()) {
        date = moment(date).format('MMM DD, YYYY HH:mm:ss');
      }
      return date;
    },
    formatPrice(val: any) {
      let date: any = val;
      return formatNumber(date);
    }
  }
})
export default class OrderItemCard extends Vue {
  @Prop() item!: any;
  @Prop() index!: number;
  @Prop() activeOrderType!: String;
  @Prop() isPaymentDetailShow!: boolean;
  @Prop(Object) orderStatus!: Object;
  @Prop(Function) handleClickCancelButton!: Function;
  @Prop(Function) handleClickDishManagement!: Function;
  @Prop(Function) handleNextStatus!: Function;
  @Prop(Function) handClickStatusButton!: Function;
  @Prop(Function) showOrderDetail!: Function;
  @Prop(Function) hideInputSearch!: Function;
  @Prop(Function) checkOrderStatusHandle!: Function;
  @Prop(Function) refundOrder!: Function;
  @Prop(Function) showPosOrder!: Function
  @Prop(Boolean) isRunner!: Boolean;
  formatPayDetails: any = this.item.paymentDetails;
  showConfirmButton: any = showConfirmButton;
  orderDetailsPrice: Array<any> = [];
  constants: any = constants;
  getOrderItemCardIcon: any = getOrderItemCardIcon;
  get checkStatus() {
    return constants.QR_TYPE.includes(this.item.paymentMethod);
  }
  get paymentMethod() {
    if (this.item.paymentMethod === 'QRPay') {
      return 'CIMB';
    }
    if (this.item.paymentMethod === 'Qris-GoPay' || this.item.paymentMethod === 'Qris-ShopeePay') {
      return 'Midtrans';
    }
    if (this.item.paymentMethod === 'Astrapay') {
      return 'Astrapay';
    }
    return '';
  }
  printHandle = (item, event) => {
    if (event) {
      event.stopPropagation
        ? event.stopPropagation()
        : (event.cancelBubble = true);
    }
    const UserName = localStorage.getItem('UserName');
    if (window && typeof (window as any).android !== 'undefined') {
      (window as any).android.printBill(JSON.stringify(item), UserName);
      (window as any).android.printBill(JSON.stringify(item), UserName, 0, 0);
    }
  };
  printMenu = (orderInfo, item, event) => {
    if (event) {
      event.stopPropagation ? event.stopPropagation() : (event.cancelBubble = true);
    }
    const UserName = localStorage.getItem('UserName');
    if (window && typeof (window as any).android !== 'undefined') {
      let printNumber = '';
      if (item.orderType === constants.ROOM) {
        printNumber = orderInfo.roomNo;
      } else {
        printNumber = orderInfo.tableNo;
      }
      const variantsNames: string[] = [];
      if (item.orderVariants && item.orderVariants.length) {
        item.orderVariants.forEach(variants => {
          if (variants.variant_details && variants.variant_details.length) {
            variants.variant_details.forEach((v: { checked: boolean; name: string }) => {
              if (v.checked) {
                variantsNames.push(v.name);
              }
            })
          }
        })
      }
      (window as any).android.printOrderMenu(
        orderInfo.orderId,
        orderInfo.orderType,
        orderInfo.checkCode,
        item.name,
        item.quantity,
        variantsNames,
        orderInfo.userName,
        printNumber,
        item.note,
        `${orderInfo.currentMenuIndex}/${orderInfo.menuLength}`,
        orderInfo.createdAt,
      );
      (window as any).android.printOrderMenu(
        orderInfo.orderId,
        orderInfo.orderType,
        orderInfo.checkCode,
        item.name,
        item.quantity,
        variantsNames,
        orderInfo.userName,
        printNumber,
        item.note,
      );
    }
  };
  printPreparedOrder = (item, event) => {
    if (event) {
      event.stopPropagation
        ? event.stopPropagation()
        : (event.cancelBubble = true);
    }
    const UserName = localStorage.getItem('UserName');
    if (window && typeof (window as any).android !== 'undefined') {
      let printNumber = '';
      if (item.orderType === constants.ROOM) {
        printNumber = item.roomNo;
      } else {
        printNumber = item.tableNo;
      }

      (window as any).android.printPreparedOrder(
        JSON.stringify(item.orderDetails),
        UserName,
        item.orderId,
        printNumber
      );

      (window as any).android.printPreparedOrder(
        JSON.stringify(item.orderDetails),
        UserName,
        item.orderId,
        printNumber,
        item.orderType
      );

      (window as any).android.printPreparedOrder(
        JSON.stringify(item.orderDetails),
        UserName,
        item.orderId,
        printNumber,
        item.orderType,
        item.createdAt,
        item.notes
      );
    }
  };
  mounted() {
    for (let key in this.item.paymentDetails) {
      this.formatPayDetails[key] = formatNumber(this.item.paymentDetails[key]);
    }
  }
}
